import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';

/**
 * # transaction
 * Factory in the coreModule. It takes care of communication with reports
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 */
@Injectable('transaction')
export class Transaction extends SpynlBase<Object> {
  protected location: string;

  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/transactions';
  }

  getTransactionObject() {
    return {
      change: 0,
      difference: 0,
      totalAmount: 0,
      totalDiscount: 0,
      overallReceiptDiscount: 0,
      totalDiscountCoupon: 0,
      totalCoupon: 0,
      totalPaid: 0,
      totalStoreCreditPaid: 0,
      receipt: [],
      type: 0,
      nr: '',
      cashier: {
        id: '',
        name: '',
      },
      shop: {
        id: '',
      },
      device: '',
      device_id: '',
      payments: {
        cash: 0,
        creditcard: 0,
        storecredit: 0,
        pin: 0,
        withdrawel: 0,
        creditreceipt: 0,
      },
      vat: {
        highamount: 0,
        highvalue: 0,
        hightotal: 0,
        lowamount: 0,
        lowvalue: 0,
        lowtotal: 0,
        zeroamount: 0,
        zerovalue: 0,
        zerototal: 0,
      },
    };
  }
}
